import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";

export const Route = createFileRoute("/cookies")({
  component: Cookies,
  head: () => ({
    meta: [
      { title: "Polityka cookies — SkuteczneStrony" },
      {
        name: "description",
        content:
          "Informacja o plikach cookie wykorzystywanych w serwisie SkuteczneStrony — rodzaje cookies, cele i sposób zarządzania zgodami.",
      },
      { property: "og:title", content: "Polityka cookies — SkuteczneStrony" },
      {
        property: "og:description",
        content: "Pliki cookie używane w serwisie i sposób zarządzania zgodami.",
      },
      { property: "og:url", content: "https://skutecznestrony.com/cookies" },
      { property: "og:type", content: "article" },
      { name: "robots", content: "index, follow" },
    ],
    links: [{ rel: "canonical", href: "https://skutecznestrony.com/cookies" }],
  }),
});

function Cookies() {
  return (
    <LegalLayout title="Polityka cookies" updated="23 czerwca 2026">
      <h2>1. Czym są pliki cookie</h2>
      <p>
        Pliki cookie (tzw. „ciasteczka") to niewielkie pliki tekstowe zapisywane w pamięci
        urządzenia użytkownika przez przeglądarkę internetową. Pozwalają one rozpoznać urządzenie
        i odpowiednio dostosować działanie serwisu.
      </p>

      <h2>2. Rodzaje cookies wykorzystywanych w Serwisie</h2>
      <ul>
        <li>
          <strong>Niezbędne</strong> — konieczne do prawidłowego działania Serwisu, np.
          obsługa sesji, bezpieczeństwo i zapamiętanie preferencji. Nie wymagają zgody
          użytkownika (art. 173 ust. 3 Prawa telekomunikacyjnego).
        </li>
        <li>
          <strong>Analityczne</strong> — pomagają mierzyć ruch i zachowanie użytkowników
          w sposób zagregowany (np. Google Analytics). Uruchamiane wyłącznie po wyrażeniu
          zgody.
        </li>
        <li>
          <strong>Marketingowe</strong> — wykorzystywane do prowadzenia kampanii i remarketingu.
          Uruchamiane wyłącznie po wyrażeniu zgody.
        </li>
      </ul>

      <h2>3. Zarządzanie cookies</h2>
      <p>
        Użytkownik w każdej chwili może zmienić ustawienia cookies w swojej przeglądarce —
        zablokować, ograniczyć lub usunąć zapisane pliki. Wyłączenie plików niezbędnych może
        ograniczyć funkcjonalność Serwisu.
      </p>
      <p>Instrukcje dla najpopularniejszych przeglądarek:</p>
      <ul>
        <li>
          <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">
            Google Chrome
          </a>
        </li>
        <li>
          <a href="https://support.mozilla.org/pl/kb/usuwanie-ciasteczek" target="_blank" rel="noopener noreferrer">
            Mozilla Firefox
          </a>
        </li>
        <li>
          <a href="https://support.apple.com/pl-pl/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">
            Safari
          </a>
        </li>
        <li>
          <a href="https://support.microsoft.com/pl-pl/windows" target="_blank" rel="noopener noreferrer">
            Microsoft Edge
          </a>
        </li>
      </ul>

      <h2>4. Logi serwera</h2>
      <p>
        Informacje o niektórych zachowaniach użytkowników podlegają logowaniu w warstwie serwerowej
        (m.in. adres IP, typ przeglądarki, czas wizyty). Dane te wykorzystywane są wyłącznie
        w celach administracyjnych i bezpieczeństwa.
      </p>

      <p>
        Więcej informacji o przetwarzaniu danych znajdziesz w naszej{" "}
        <a href="/polityka-prywatnosci">Polityce prywatności</a>.
      </p>
    </LegalLayout>
  );
}
